import { Base } from 'app/components/ui/Base'
import { Container } from 'app/components/ui/Container'
import { Text } from 'app/components/ui/Text'
import { useLayout } from 'app/contexts/LayoutProvider'
import { routes } from 'app/routing/routes'
import { parse } from 'query-string'
import React, { useLayoutEffect } from 'react'
import { Redirect, useLocation } from 'react-router-dom'
import styled from 'styled-components'

import { ResetPasswordForm } from './ResetPasswordForm'

export const ResetPassword = (): JSX.Element => {
  // Get reset token from url
  const { search } = useLocation()

  const { updateLayoutData } = useLayout()

  useLayoutEffect(() => {
    updateLayoutData({
      title: 'Reset Password',
      subTitle: 'Inserisci la tua nuova password.',
      headerVariant: 'authentication',
    })
  }, [updateLayoutData])

  const queryObject = parse(search)

  const reset_token = queryObject['reset_token']
    ? `${queryObject['reset_token']}`
    : undefined

  if (!reset_token) {
    return <Redirect to={routes.login.path} />
  }

  return (
    <Base>
      <Container>
        <PageGrid>
          <TextColumn>
            <Text variant='s20' weight='700' mb={2}>
              INSERISCI LA TUA NUOVA PASSWORD
            </Text>
            <Text variant='s20'>Rispetta le indicazioni:</Text>
            <Text variant='s14' isItalic>
              Almeno 8 caratteri{'\n'}
              Almeno una lettera maiuscola (es. ABCD){'\n'}
              Almeno un numero (es. 1234){'\n'}
              Almeno un carattere speciale (es. !?=/)
            </Text>
          </TextColumn>
          <FormColumn>
            <ResetPasswordForm token={reset_token}></ResetPasswordForm>
          </FormColumn>
        </PageGrid>
      </Container>
    </Base>
  )
}

const PageGrid = styled.div`
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;

  display: grid;
  grid-gap: 4rem;

  grid-template-columns: 1fr;

  grid-template-areas:
    'text'
    'form';

  @media (min-width: ${({ theme }) => theme.bp.tablet}) {
    grid-template-columns: auto 500px auto;

    grid-template-areas:
      '. text .'
      '. form .';
  }

  @media (min-width: ${({ theme }) => theme.bp.desktop}) {
    grid-template-columns: 1fr 1fr;
    grid-template-areas: 'text form';

    margin-bottom: 2rem;
  }
`

const TextColumn = styled.div`
  grid-area: text;

  text-align: center;

  @media (min-width: ${({ theme }) => theme.bp.desktop}) {
    text-align: left;
  }
`
const FormColumn = styled.div`
  grid-area: form;
`
